import { createStore } from "vuex";
import login from "./modules/permission";
import decorate from "./modules/decorate";

export default createStore({
  state: {
    tagsList: [],
    collapse: false, //侧边栏展开隐藏信号 false 展开  true 隐藏
    updateSign: false, //app跳转刷新侧边菜单数据
    appIndexUrl: "/", //app首页跳转地址
    showMapSel: false,
    agreementData: {},
    tabN: "", // 用于配置协议回到协议配置列表时激活tab标签
    selLinkData: "", //选择链接数据，用于缓存

    contentWidth: "", //内容区宽度
  },
  getters: {
    getUpdateSign(state) {
      return state.updateSign;
    },
  },
  mutations: {
    setTabN(state, data) {
      state.tabN = data;
    },
    clearTabN(state, data) {
      state.tabN = data;
    },
    delTagsItem(state, data) {
      state.tagsList.splice(data.index, 1);
    },
    setTagsItem(state, data) {
      // console.log(state,data)
      state.tagsList.push(data);
    },
    clearTags(state) {
      state.tagsList = [];
    },
    closeTagsOther(state, data) {
      state.tagsList = data;
    },
    closeCurrentTag(state, data) {
      for (let i = 0, len = state.tagsList.length; i < len; i++) {
        const item = state.tagsList[i];
        if (item.path === data.$route.fullPath) {
          if (i < len - 1) {
            data.$router.push(state.tagsList[i + 1].path);
          } else if (i > 0) {
            data.$router.push(state.tagsList[i - 1].path);
          } else {
            data.$router.push("/");
          }
          state.tagsList.splice(i, 1);
          break;
        }
      }
    },
    // 侧边栏折叠
    hadndleCollapse(state, data) {
      state.collapse = data;
      setTimeout(() => {
        // 计算内容区
        let width = document.getElementById("content");
        state.contentWidth = width.offsetWidth;
      }, 1000);
    },

    // 刷新侧边栏和顶部栏
    handleUpdateSign(state, data) {
      state.updateSign = data;
    },

    // 更新app首页跳转地址
    // handleUpdateSign(state, data) {
    // 	state.updateSign = data;
    // },
  },
  actions: {},
  modules: {
    login,
    decorate,
  },
});
